import { EventEmitter, Injectable, Output } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { GetMediaForSectionResponse } from "../components/utility/GetMediaForSectionResponse";
import { LinkObject } from "../components/utility/LinkObject";
import { ContactObject } from "../components/utility/ContactObject";
import { HtmlTextObject } from "../components/utility/HtmlTextObject";
import { UpdateMediaRequest } from "../components/utility/UpdateMediaRequest";

@Injectable({
  providedIn: "root",
})
export class DynamicHomepageService {
  @Output() editingHomepage: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  constructor(private readonly http: HttpClient) {}

  public enableHomepageEditor(): void {
    this.editingHomepage.emit(true);
  }

  public disableHomepageEditor(): void {
    this.editingHomepage.emit(false);
  }

  public getMediaForSection(
    sectionId: string
  ): Observable<GetMediaForSectionResponse> {
    return this.http.get<GetMediaForSectionResponse>(
      `${environment.serviceURL}/mediaForSection?sectionId=${sectionId}`
    );
  }

  public getLinkById(linkId: any): Observable<LinkObject> {
    return this.http.get<any>(
      `${environment.serviceURL}/link?linkId=${linkId}`
    );
  }

  public getContactById(contactId: any): Observable<ContactObject> {
    return this.http.get<any>(
      `${environment.serviceURL}/contact?contactId=${contactId}`
    );
  }

  public getHtmlTextById(htmlTextId: any): Observable<HtmlTextObject> {
    return this.http.get<any>(
      `${environment.serviceURL}/htmlText?htmlTextId=${htmlTextId}`
    );
  }

  public createLink(link: LinkObject): Observable<any> {
    return this.http.post<any>(`${environment.serviceURL}/createLink`, link);
  }

  public createContact(contact: ContactObject): Observable<any> {
    return this.http.post<any>(
      `${environment.serviceURL}/createContact`,
      contact
    );
  }

  public createHtmlText(htmlText: HtmlTextObject): Observable<any> {
    return this.http.post<any>(
      `${environment.serviceURL}/createHtmlText`,
      htmlText
    );
  }

  public deleteMediaById(id: any): Observable<any> {
    return this.http.post<any>(
      `${environment.serviceURL}/deleteMedia?mediaId=${id}`,
      id
    );
  }

  public updateMedia(req: UpdateMediaRequest): Observable<any> {
    return this.http.post<any>(
      `${environment.serviceURL}/updateMedia?mediaId=${req.mediaId}`,
      req
    );
  }

  public updateAnnouncement(announcement: any): Observable<any> {
    return this.http.put(
      `${environment.serviceURL}/updateAnnouncement`,
      announcement
    );
  }
}
